// extracted by mini-css-extract-plugin
export default {"profilePage":"styles_profilePage__Vwrmt","profileTitle":"styles_profileTitle__lrzPo"};